export const resources = {
  mainIndexPath: 'https://rallyup.com',
  defaultLogoUrl: 'https://go.rallyup.com/Content/images/rallyup_com_black_small.png',
  donationPage: {
    bgImageName: 'DonationPageBackgroundPreview.png',
    addImage: 'https://go.rallyup.com/Content/images/setup/media.png',
    primaryCurrenctLearnMore: 'https://community.rallyup.com/t/360mcg/how-to-set-your-home-currency-in-rallyup',
  },
  customFieldImg: 'https://go.rallyup.com/content/images/setup/custom-field.png',
  beamer: {
    scriptUrl: 'https://app.getbeamer.com/js/beamer-embed.js',
  },
  images: {
    appDefaultLogo: '', // no default logo #18715
    shoppingCart: 'https://go.rallyup.com/Content/header-icons/ICON_ShoppingCartNew.svg',
  },
  links: {
    community: 'https://community.rallyup.com',
    termsOfService: 'https://rallyup.com/terms-of-service',
  },
};
